// Centralized data-testid constants for the Sahraoui Promotion site

export const HOME = {
  emergentLink: "home-emergent-link",
  heroCta: "home-hero-cta",
  heroSecondaryCta: "home-hero-secondary-cta",
  servicesLink: "home-services-link",
  projectsLink: "home-projects-link",
};

export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  about: "nav-about",
  services: "nav-services",
  projects: "nav-projects",
  availabilities: "nav-availabilities",
  gallery: "nav-gallery",
  contact: "nav-contact",
  mobileToggle: "nav-mobile-toggle",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logout: "admin-logout",
  tabCompany: "admin-tab-company",
  tabServices: "admin-tab-services",
  tabProjects: "admin-tab-projects",
  tabAvailabilities: "admin-tab-availabilities",
  tabGallery: "admin-tab-gallery",
  tabMessages: "admin-tab-messages",
  tabSettings: "admin-tab-settings",
};
